import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/common/ScrollToTop';
import Home from './pages/Home';
import WhyExitReady from './pages/WhyExitReady';
import WhatsIncluded from './pages/WhatsIncluded';
import WhoItsFor from './pages/WhoItsFor';
import WhatWeBuild from './pages/WhatWeBuild';
import Contact from './pages/Contact';
import './styles/global.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/why-exit-ready" element={<WhyExitReady />} />
            <Route path="/whats-included" element={<WhatsIncluded />} />
            <Route path="/who-its-for" element={<WhoItsFor />} />
            <Route path="/what-we-build" element={<WhatWeBuild />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;